import { useEffect, useState } from "react";
import { track } from "@/lib/analytics";

const LINKS = [
  { id: "edition-tribal-goddess", label: "Tribal Goddess" },
  { id: "edition-universal-soul-of-stars", label: "Universal Soul" },
  { id: "collector-pair", label: "The Pair" },
  { id: "chapter-ii", label: "Chapter II" },
  { id: "recognition", label: "Recognition" },
];

export const Nav190 = () => {
  const [solid, setSolid] = useState(false);

  useEffect(() => {
    const onScroll = () => setSolid(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    track("nav_click", { section: id });
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <header
        data-testid="the190-nav"
        className="fixed top-0 left-0 right-0 z-50 transition-colors duration-500 text-[color:var(--ink)]"
        style={{
          backgroundColor: solid ? "rgba(238, 231, 217, 0.96)" : "transparent",
          backdropFilter: solid ? "blur(6px)" : "none",
          borderBottom: solid ? "1px solid rgba(18,18,18,0.08)" : "1px solid transparent",
        }}
      >
        <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-4 md:py-5 flex items-center justify-between">
          <button
            type="button"
            onClick={() => go("the-190-top")}
            className="font-wordmark text-2xl md:text-3xl tracking-wider leading-none text-left"
            data-testid="the190-brand"
          >
            Collector Editions
          </button>
          <nav className="hidden md:flex items-center gap-8">
            {LINKS.map((l) => (
              <button
                key={l.id}
                type="button"
                onClick={() => go(l.id)}
                className="hairline opacity-65 hover:opacity-100 transition-opacity duration-500"
                data-testid={`the190-nav-${l.id}`}
              >
                {l.label}
              </button>
            ))}
            <button
              type="button"
              onClick={() => {
                track("cta_click", { cta: "nav-collect" });
                go("collect");
              }}
              className="hairline bg-[color:var(--ink)] text-[color:var(--bone)] px-5 py-2.5 hover:bg-[color:var(--oxblood)] transition-colors duration-500"
              data-testid="the190-nav-collect"
            >
              Collect
            </button>
          </nav>
          <button
            type="button"
            onClick={() => {
              track("cta_click", { cta: "nav-collect-mobile" });
              go("collect");
            }}
            className="md:hidden hairline bg-[color:var(--ink)] text-[color:var(--bone)] px-4 py-2.5"
            data-testid="the190-nav-collect-mobile"
          >
            Collect
          </button>
        </div>
      </header>

      {/* Sticky mobile CTA — scrolls to Collect section */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 z-50 p-3 bg-gradient-to-t from-black/70 to-transparent pointer-events-none">
        <button
          type="button"
          onClick={() => {
            track("cta_click", { cta: "sticky-mobile" });
            document.getElementById("collect")?.scrollIntoView({ behavior: "smooth" });
          }}
          className="pointer-events-auto hairline block w-full text-center bg-[color:var(--ink)] text-[color:var(--bone)] border border-white/20 py-4 !text-[0.75rem]"
          data-testid="the190-sticky-cta"
        >
          Collect an Edition
        </button>
      </div>
    </>
  );
};

export default Nav190;
